// grensesnitt/accordion-item: each button names its panel in aria-controls.
document.querySelectorAll( 'section.accordions .accordion' ).forEach( button => {
    const item = button.closest( '.accordions__item' )

    button.addEventListener( 'click', () => {
        const open = !item.classList.contains( 'open' )
        item.classList.toggle( 'open', open )
        button.setAttribute( 'aria-expanded', open ? 'true' : 'false' )
    } )
} )
